/**
 * Card rendering public surface. Registers the token art table on import so
 * CardView can resolve token art without src/ui/cards depending on src/data
 * at module scope inside cardView.ts.
 */

import { allTokens } from '@/data';
import { registerTokenArt } from './cardView';

const table: Record<string, string> = {};
for (const token of allTokens) {
  if (token.art?.path) table[token.id] = token.art.path;
}
registerTokenArt(table);

export { CardFrame, CardBack, type CardFrameProps, type CardSize } from './CardFrame';
export { CardArt, artUrl } from './CardArt';
export { CostPips, costLabel } from './CostPips';
export {
  viewFromCard,
  viewFromToken,
  viewFromObject,
  costTotalOf,
  type CardView,
  type AttachedChip,
} from './cardView';
